require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./member-vicky-zina-dizon.json") })
        }
      }, "path---member-vicky-zina-dizon");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---member-vicky-zina-dizon!./.cache/json/member-vicky-zina-dizon.json
// module id = 410
// module chunks = 231608221292675